import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgShipping({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 17A2 2 0 1114.268 20H9.732a2 2 0 110-2.001h4.536A2 2 0 0116 17zm0-10a1 1 0 01.993.883L17 8c0 .3.147.582.393.754l3.33 2.33a3 3 0 011.28 2.458V17c0 1.083-.58 2.066-1.5 2.598a1 1 0 01-1.099-1.667l.098-.064a.999.999 0 00.5-.867v-3.458a1 1 0 00-.426-.82L17 10.92V13h1a1 1 0 110 2h-2a.997.997 0 01-1-1V8a1 1 0 011-1zm-1-3a1 1 0 110 2H5a1 1 0 00-1 1v10c0 .321.152.615.402.802l.098.064a1 1 0 01-1.003 1.73A2.999 2.999 0 012 17V7a3 3 0 013-3h10zm-5 5a1 1 0 110 2H7a1 1 0 110-2h3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgShipping
